<template>
  <GridRow class="services">
    <GridColumn
      v-for="tile in tiles"
      :key="tile.headline"
      :no-gutter="false"
      :xs="12"
      :sm="6"
      :md="3"
      class="services__tile"
    >
      <div class="services__tile-content">
        <Heading
          tag="h3"
          size="sm"
          font-weight="regular"
          align="center"
        >
          {{ tile.headline }}
        </Heading>
        <CdnImage
          class="services__tile-img filter-invert"
          :src="tile.image"
          :height="48"
          :alt="tile.headline"
          render-without-figure
          lazy
        />
        <Paragraph
          class="services__tile-content-paragraph"
          align="center"
          :text="tile.description"
        />
        <Paragraph
          class="services__tile-content-paragraph--footer"
          align="center"
          :text="tile.footer"
        />
      </div>
    </GridColumn>
  </GridRow>
</template>

<script setup lang="ts">
import { GridRow, GridColumn, Heading, Paragraph } from '@i22/td-longtail-vue-components';
import CdnImage from '@/components/cdn-image.vue';

const tiles = [
  {
    headline: 'Kontakt & Service',
    image:
      '/content/content-images/homepage/services/ae188686c51d68e709f8a65be0ab4b9b/call-center.svg',
    description: 'Kostenlos, rund um die Uhr,<br>7 Tage die Woche',
    footer: 'Bestellhotline: <a href="tel:0800 33 03000" class="link">0800 33 03000</a>',
  },
  {
    headline: 'Lieferung & Retoure',
    image: '/content/content-images/homepage/services/b13b5be25acb148dd44c5af876ad7ec4/package.svg',
    description: 'Kostenlose Lieferung & Retoure<br>Lieferzeit bei Verfügbarkeit:<br>1-3 Werktage',
  },
  {
    headline: 'Zahlungsoptionen',
    image: '/content/content-images/homepage/services/7e38a8e74a3d56969b86029170d4a83c/euro.svg',
    description:
      'Direktzahlung mit Paypal Express<br>Weitere Zahlungsmethoden:<br>Paypal, Mastercard, Visa oder Nachnahme',
  },
  {
    headline: 'Hilfe & Community',
    image: '/content/content-images/homepage/services/35a7040ce80c379f0a8d47d9bc48324d/chat.svg',
    description:
      'Hier bekommst Du Anregungen und Hilfe zu allen Themen rund um Lösungen der Telekom.',
    footer: `<a href="https://telekomhilft.telekom.de/" target="_blank" class="link link--external">Zur Community <span class="sr-only">(Der Link wird in einem neuen Tab geöffnet)</span></a>`,
  },
];
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.services {
  &__tile {
    @include mq($mq-sm) {
      margin-bottom: $grid-base * 2;
    }

    &-content {
      background-color: var(--mode-basic-background-card);
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      gap: $grid-base;
      padding: 2 * $grid-base $grid-base 0 $grid-base;
      text-align: center;
      height: 100%;

      &-paragraph {
        &--footer {
          font-weight: 700;
          margin-top: -24px;
        }
      }
    }
  }
}
</style>
